import { CommonModule, formatDate } from '@angular/common';
import { Component, TemplateRef, ViewChild } from '@angular/core';
import { NgbModalConfig, NgbModal, NgbOffcanvas, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerModule, NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { FileService } from '../../../../core/services/file.service';
import { ProgramService } from '../../../../core/services/program.service';
import { TextbookTaskService } from '../../../../core/services/textbook-task.service';
import { TextbookService } from '../../../../core/services/textbook.service';
import { AppErrorShow } from '../../../../core/utils/app-error-show';
import { AppSweetAlert } from '../../../../core/utils/app-sweet-alert';
import { LocalStorageService } from '../../../../core/utils/local-stoarge-service';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { SampleSearchPipe } from '../../../../core/pipes/sample-search.pipe';
import { LoadingComponent } from '../../../components/loading/loading.component';
import { HeaderComponent } from '../../../admin/layout/includes/header/header.component';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import { NgxPaginationModule } from 'ngx-pagination';
import { TimeTableItemComponent } from '../../../components/time-table-item/time-table-item.component';

@Component({
    selector: 'app-textbook',
    templateUrl: './textbook.component.html',
    imports: [
        TimeTableItemComponent,
        CommonModule, FormsModule, NgbModule, LoadingComponent, SampleSearchPipe, HeaderComponent, NgSelectModule, NgxExtendedPdfViewerModule, NgxSpinnerModule, NgxPaginationModule
    ],
    styleUrls: ['./textbook.component.css']
})
export class TextbookComponent {
  loading:any
  @ViewChild('contentPDF') contentPDF:TemplateRef<any> | undefined

  data:any[] =[]
  textbooks:any[] =[]
  tasks:any[] =[]
  paccId:any
  tbId:any
  current:any
  fileInput:any
  selected_data:any
  currentDate= new Date();
  tag="professors-textbook"
  pdfViewLoader=false
  pdfSrc = "https://vadimdez.github.io/ng2-pdf-viewer/assets/pdf-test.pdf";

  constructor(
    private spinnerService:NgxSpinnerService,
    private fileService:FileService,
    private programService:ProgramService,
    private tbService:TextbookService,
    private tbtService:TextbookTaskService,
    private toastrService:ToastrService,
    private offcanvasService: NgbOffcanvas,
    private spinner: NgxSpinnerService,
      config: NgbModalConfig,
      private lsService:LocalStorageService,
    private modalService: NgbModal) {
     config.backdrop = 'static';
     config.keyboard = false;
     }
  
    ngOnInit(){
  
      this.getAll()
    }
  
     
    upload(event:any){
      if (event.target.files.length!=0) {
        this.fileInput=event.target.files[0]
      }
    }
  
    getAll(){
      this.spinner.show();
      this.programService.getProfessorDayPrograms(this.currentDate.getDay()).subscribe((res:any)=>{
        this.spinner.hide();
        this.data=res.data
      },
      (err:any)=>{
        this.spinner.hide();
        AppErrorShow.showError("Mon cahier de texte",err)

      })
    }

    edit(content:any,el:any){
      this.selected_data=el
      this.modalService.open(content,{size:'lg'});
  
    }

    loadTextBook(el:any,index?:any){
      if(index!=undefined)this.current=index
      console.log(this.current)
      this.paccId=el.pacc_id
      this.tbService.getByPacc(this.paccId).subscribe((res:any)=>{
        this.textbooks=res.data
      },
      (err:any)=>{
        AppErrorShow.showError("Mon cahier de texte",err)

      })
    }
    loadTextBookTask(id:any){
      this.tbId=id
      this.tbtService.getByTextbook(id).subscribe((res:any)=>{
        this.tasks=res.data
      },
      (err:any)=>{
        AppErrorShow.showError("Mon cahier de texte",err)

      })
    }

    storeTextbook(form:any){
      let formData= new FormData()
      for (const key in form.value) {
        if (Object.prototype.hasOwnProperty.call(form.value, key)) {
          const element = form.value[key];
          formData.append(key,element)
        }
      }
      formData.append('pacc_id',this.paccId)

      if (this.fileInput != undefined) {
        formData.append('filename',this.fileInput)

      }

      this.tbService.store(formData).subscribe((res:any)=>{
        form.resetForm()
        this.loadTextBook(this.paccId)
      },
      (err:any)=>{
        AppErrorShow.showError("Mon cahier de texte",err)

      })
  }
  storeTask(form:any){
      let formData= new FormData()
      for (const key in form.value) {
        if (Object.prototype.hasOwnProperty.call(form.value, key)) {
          const element = form.value[key];
          formData.append(key,element)
        }
      }
      formData.append('textbook_id',this.tbId)

      if (this.fileInput != undefined) {
        formData.append('filename',this.fileInput)

      }

      this.tbtService.store(formData).subscribe((res:any)=>{
        form.resetForm()
        this.loadTextBookTask(this.tbId)
      },
      (err:any)=>{
        AppErrorShow.showError("Mon cahier de texte",err)

      })
  }

  getFile(code:any,folder:any,filename:any,css='details-panel'){
    this.spinnerService.show()
    this.pdfViewLoader=true
    this.fileService.get({
      folder:folder,
      code:code,
      filename:filename
    }).subscribe((res:any)=>{
      this.spinnerService.hide()
      this.pdfViewLoader=false
      this.pdfSrc=res[0]
      this.offcanvasService.open(this.contentPDF,{  panelClass: css, position: 'end'  });

    },
    (err:any)=>{
      this.spinner.hide()
      AppErrorShow.showError("Mon cahier de texte",err)

    })
  }

  getDateWithFormat(){
    return formatDate(this.currentDate,'EEE dd LLL','fr_FR')
  }

  previousDate(){
    this.currentDate=new Date(this.currentDate.setDate(this.currentDate.getDate() - 1));
    this.getDateWithFormat()
    this.getAll()

  }
  nextDate(){
    this.currentDate=new Date(this.currentDate.setDate(this.currentDate.getDate() + 1));
    this.getDateWithFormat()
    this.getAll()
  }

  update(value:any){
    this.loading=true

    this.tbService.update(this.selected_data.id,value).subscribe((res:any)=>{
      this.modalService.dismissAll()
      this.loading=false
      this.tbService.getByPacc(this.paccId).subscribe((res:any)=>{
        this.textbooks=res.data
      },
      (err:any)=>{
        AppErrorShow.showError("Mon cahier de texte",err)

      })
        this.toastrService.success(res.message)
    },
    (err:any)=>{
      this.loading=false

      console.log(err)
        AppErrorShow.showError("Gestion des classes apprenants",err)

    })
  }
  update2(value:any){
    this.loading=true

    this.tbtService.update(this.selected_data.id,value).subscribe((res:any)=>{
      this.modalService.dismissAll()
      this.loading=false
      this.tbtService.getByTextbook(this.tbId).subscribe((res:any)=>{
        this.tasks=res.data
      },
      (err:any)=>{
        AppErrorShow.showError("Mon cahier de texte",err)

      })
        this.toastrService.success(res.message)
    },
    (err:any)=>{
      this.loading=false

      console.log(err)
        AppErrorShow.showError("Gestion des classes apprenants",err)

    })
  }

  delete(el:any){
    let confirmed=AppSweetAlert.confirmBox('info','Suppression','Voulez vous vraiment retirer cet élément?',);
    confirmed.then((result:any)=>{
       if (result.isConfirmed) {
    this.tbService.delete(el.id).subscribe((res:any)=>{
        this.toastrService.success(res.message)
        this.tbService.getByPacc(this.paccId).subscribe((res:any)=>{
          this.tasks=res.data
        },
        (err:any)=>{
          AppErrorShow.showError("Mon cahier de texte",err)
  
        })
    },
    (err:any)=>{
      console.log(err)
        AppErrorShow.showError("Gestion des classes apprenants",err)

    })
  }
})
  }

  delete2(el:any){
    let confirmed=AppSweetAlert.confirmBox('info','Suppression','Voulez vous vraiment retirer cet élément?',);
    confirmed.then((result:any)=>{
       if (result.isConfirmed) {
    this.tbtService.delete(el.id).subscribe((res:any)=>{
        this.toastrService.success(res.message)

        this.tbtService.getByTextbook(this.tbId).subscribe((res:any)=>{
          this.tasks=res.data
        },
        (err:any)=>{
          AppErrorShow.showError("Mon cahier de texte",err)
  
        })
    },
    (err:any)=>{
      console.log(err)
        AppErrorShow.showError("Gestion des classes apprenants",err)

    })
  }
})
  }
}
